import React, { useEffect, useState } from "react";
import api from "../axios";

export default function FollowupSequences() {
  const [sequences, setSequences] = useState([]);
  const [selectedSequence, setSelectedSequence] = useState(null);
  const [messages, setMessages] = useState([]);
  const [sequenceName, setSequenceName] = useState("");

  const [messageForm, setMessageForm] = useState({
    day_number: 1,
    message_text: ""
  });

  const loadSequences = async () => {
    try {
      const res = await api.get("/followup-sequences");
      setSequences(res.data);
    } catch (err) {
      alert(err.response?.data?.msg || "Failed to load sequences");
    }
  };

  const loadMessages = async (sequence) => {
    try {
      setSelectedSequence(sequence);
      const res = await api.get(`/followup-sequences/${sequence.id}/messages`);
      setMessages(res.data);
    } catch (err) {
      alert(err.response?.data?.msg || "Failed to load messages");
    }
  };

  useEffect(() => {
    loadSequences();
  }, []);

  const createSequence = async (e) => {
    e.preventDefault();
    if (!sequenceName.trim()) return alert("Sequence name required");

    try {
      await api.post("/followup-sequences", { name: sequenceName });
      setSequenceName("");
      loadSequences();
    } catch (err) {
      alert(err.response?.data?.msg || "Failed to create sequence");
    }
  };

  const addMessage = async (e) => {
    e.preventDefault();

    if (!selectedSequence) return alert("Please select sequence");
    if (!messageForm.message_text.trim()) return alert("Message required");

    try {
      await api.post(
        `/followup-sequences/${selectedSequence.id}/messages`,
        messageForm
      );

      setMessageForm({
        day_number: 1,
        message_text: ""
      });

      loadMessages(selectedSequence);
    } catch (err) {
      alert(err.response?.data?.msg || "Failed to add message");
    }
  };

  const deleteMessage = async (messageId) => {
    if (!window.confirm("Delete this message?")) return;

    try {
      await api.delete(`/followup-sequences/messages/${messageId}`);
      loadMessages(selectedSequence);
    } catch (err) {
      alert(err.response?.data?.msg || "Failed to delete message");
    }
  };

  const toggleStatus = async (sequence) => {
    try {
      const newStatus = sequence.status ? 0 : 1;

      await api.put(`/followup-sequences/${sequence.id}/status`, {
        status: newStatus
      });

      loadSequences();

      if (selectedSequence?.id === sequence.id) {
        setSelectedSequence({
          ...sequence,
          status: newStatus
        });
      }
    } catch (err) {
      alert(err.response?.data?.msg || "Failed to update status");
    }
  };

  return (
    <div className="followup-page">
      <div className="followup-header">
        <div>
          <h2>Follow-up Sequences</h2>
          <p>Create automatic follow-up messages for your leads.</p>
        </div>
      </div>

      <div className="followup-grid">
        <div className="followup-left">
          <div className="crm-card">
            <h4>Create New Sequence</h4>

            <form onSubmit={createSequence}>
              <label>Sequence Name</label>
              <input
                type="text"
                placeholder="Example: New Lead Follow-up"
                value={sequenceName}
                onChange={(e) => setSequenceName(e.target.value)}
              />

              <button className="primary-btn">+ Create Sequence</button>
            </form>
          </div>

          <div className="crm-card mt-3">
            <h4>All Sequences</h4>

            {sequences.length === 0 && (
              <div className="empty-box">No sequence found</div>
            )}

            <div className="sequence-list">
              {sequences.map((seq) => (
                <div
                  key={seq.id}
                  className={`sequence-item ${
                    selectedSequence?.id === seq.id ? "active" : ""
                  }`}
                >
                  <div onClick={() => loadMessages(seq)}>
                    <h5>{seq.name}</h5>
                    <span
                      className={
                        seq.status ? "status active-status" : "status off-status"
                      }
                    >
                      {seq.status ? "Active" : "Inactive"}
                    </span>
                  </div>

                  <button
                    className={seq.status ? "disable-btn" : "enable-btn"}
                    onClick={() => toggleStatus(seq)}
                  >
                    {seq.status ? "Disable" : "Enable"}
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="followup-right">
          {!selectedSequence ? (
            <div className="crm-card center-card">
              <h3>Select Sequence</h3>
              <p>Left side se sequence select karo aur usme messages add karo.</p>
            </div>
          ) : (
            <>
              <div className="crm-card">
                <div className="section-title">
                  <div>
                    <h4>Add Message</h4>
                    <p>{selectedSequence.name}</p>
                  </div>

                  <span
                    className={
                      selectedSequence.status
                        ? "status active-status"
                        : "status off-status"
                    }
                  >
                    {selectedSequence.status ? "Active" : "Inactive"}
                  </span>
                </div>

                <form onSubmit={addMessage}>
                  <div className="form-row">
                    <div>
                      <label>Day Number</label>
                      <input
                        type="number"
                        min="1"
                        value={messageForm.day_number}
                        onChange={(e) =>
                          setMessageForm({
                            ...messageForm,
                            day_number: e.target.value
                          })
                        }
                      />
                    </div>

                    <div className="message-field">
                      <label>Message Text</label>
                      <textarea
                        rows="4"
                        placeholder="Example: Namaste {{name}}, aapki inquiry receive ho gayi hai..."
                        value={messageForm.message_text}
                        onChange={(e) =>
                          setMessageForm({
                            ...messageForm,
                            message_text: e.target.value
                          })
                        }
                      />
                    </div>
                  </div>

                  <button className="primary-btn">Add Message</button>
                </form>
              </div>

              <div className="crm-card mt-3">
                <h4>Sequence Messages</h4>

                {messages.length === 0 ? (
                  <div className="empty-box">No messages added</div>
                ) : (
                  <div className="message-list">
                    {messages.map((msg) => (
                      <div className="message-card" key={msg.id}>
                        <div className="day-badge">Day {msg.day_number}</div>

                        <div className="message-content">
                          {msg.message_text}
                        </div>

                        <button
                          className="delete-btn"
                          onClick={() => deleteMessage(msg.id)}
                        >
                          Delete
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>

      <style>{`
        .followup-page {
          padding: 24px;
          background: #f4f7fb;
          min-height: 100vh;
        }

        .followup-header {
          background: linear-gradient(135deg, #111827, #2563eb);
          color: white;
          padding: 24px;
          border-radius: 18px;
          margin-bottom: 24px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.12);
        }

        .followup-header h2 {
          margin: 0;
          font-size: 28px;
          font-weight: 700;
        }

        .followup-header p {
          margin: 6px 0 0;
          color: #dbeafe;
        }

        .followup-grid {
          display: grid;
          grid-template-columns: 360px 1fr;
          gap: 22px;
        }

        .crm-card {
          background: white;
          border-radius: 18px;
          padding: 20px;
          box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
          border: 1px solid #eef2f7;
        }

        .crm-card h4 {
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 16px;
          color: #111827;
        }

        label {
          font-weight: 600;
          font-size: 14px;
          color: #374151;
          margin-bottom: 6px;
          display: block;
        }

        input, textarea {
          width: 100%;
          border: 1px solid #d1d5db;
          border-radius: 12px;
          padding: 12px 14px;
          font-size: 15px;
          outline: none;
          margin-bottom: 14px;
          background: #f9fafb;
        }

        input:focus, textarea:focus {
          border-color: #2563eb;
          background: white;
          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
        }

        .primary-btn {
          background: #2563eb;
          color: white;
          border: none;
          border-radius: 12px;
          padding: 12px 18px;
          font-weight: 700;
          cursor: pointer;
          transition: 0.2s;
        }

        .primary-btn:hover {
          background: #1d4ed8;
        }

        .mt-3 {
          margin-top: 18px;
        }

        .sequence-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .sequence-item {
          border: 1px solid #e5e7eb;
          border-radius: 14px;
          padding: 14px;
          background: #f9fafb;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
        }

        .sequence-item.active {
          border-color: #2563eb;
          background: #eff6ff;
        }

        .sequence-item h5 {
          margin: 0 0 8px;
          font-size: 15px;
          font-weight: 700;
          color: #111827;
          cursor: pointer;
        }

        .status {
          display: inline-block;
          padding: 5px 10px;
          border-radius: 999px;
          font-size: 12px;
          font-weight: 700;
        }

        .active-status {
          color: #047857;
          background: #d1fae5;
        }

        .off-status {
          color: #b91c1c;
          background: #fee2e2;
        }

        .enable-btn, .disable-btn, .delete-btn {
          border: none;
          border-radius: 10px;
          padding: 8px 12px;
          font-size: 13px;
          font-weight: 700;
          cursor: pointer;
        }

        .enable-btn {
          background: #16a34a;
          color: white;
        }

        .disable-btn {
          background: #f59e0b;
          color: #111827;
        }

        .delete-btn {
          background: #ef4444;
          color: white;
        }

        .center-card {
          text-align: center;
          padding: 80px 20px;
          color: #6b7280;
        }

        .center-card h3 {
          color: #111827;
          font-weight: 700;
        }

        .section-title {
          display: flex;
          justify-content: space-between;
          align-items: start;
          margin-bottom: 12px;
        }

        .section-title h4 {
          margin-bottom: 2px;
        }

        .section-title p {
          margin: 0;
          color: #6b7280;
        }

        .form-row {
          display: grid;
          grid-template-columns: 160px 1fr;
          gap: 16px;
        }

        .message-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .message-card {
          display: grid;
          grid-template-columns: 90px 1fr 90px;
          gap: 14px;
          align-items: center;
          padding: 14px;
          border: 1px solid #e5e7eb;
          border-radius: 14px;
          background: #f9fafb;
        }

        .day-badge {
          background: #111827;
          color: white;
          padding: 8px 10px;
          border-radius: 10px;
          text-align: center;
          font-weight: 700;
          font-size: 13px;
        }

        .message-content {
          color: #374151;
          line-height: 1.5;
          white-space: pre-wrap;
        }

        .empty-box {
          padding: 20px;
          background: #f9fafb;
          border-radius: 14px;
          text-align: center;
          color: #6b7280;
          border: 1px dashed #d1d5db;
        }

        @media (max-width: 900px) {
          .followup-grid {
            grid-template-columns: 1fr;
          }

          .form-row {
            grid-template-columns: 1fr;
          }

          .message-card {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
  );
}